import React, { useEffect, useState } from 'react';

import './index.scss';

const ROWS = ['r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7'];
const TREE_ROWS = ['t1', 't2', 't3', 't4', 't5', 't6'];
/** Depois disto a espera deixa de parecer normal e o aviso explica o motivo. */
export const SLOW_HINT_MS = 4000;

interface Props {
  /** Desktop com a árvore lateral: reserva a coluna para a tabela não pular quando ela chegar. */
  showTree?: boolean;
}

/** Esqueleto da lista: a página já mostra a forma do conteúdo enquanto a árvore chega. */
export default function LoadingState({ showTree = false }: Props) {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsSlow(true), SLOW_HINT_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="file-explorer-loading" role="status" aria-label="Carregando arquivos">
      {showTree && (
        <div className="file-explorer-loading-tree" aria-hidden="true">
          <span className="file-explorer-skeleton is-tree-title" />
          {TREE_ROWS.map((row, i) => (
            <div
              key={row}
              className="file-explorer-loading-tree-row"
              style={{ paddingLeft: 14 + (i % 3) * 12 }}
            >
              <span className="file-explorer-skeleton is-tree-icon" />
              <span className="file-explorer-skeleton is-name" style={{ width: `${64 - (i % 3) * 12}%` }} />
            </div>
          ))}
        </div>
      )}
      <div className="file-explorer-loading-table">
        {ROWS.map((row, i) => (
          <div key={row} className="file-explorer-loading-row">
            <span className="file-explorer-skeleton is-icon" />
            <span className="file-explorer-skeleton is-name" style={{ width: `${62 - (i % 3) * 14}%` }} />
            <span className="file-explorer-skeleton is-meta" />
          </div>
        ))}
        {isSlow && (
          <p className="file-explorer-loading-hint">A lista é grande e pode levar alguns segundos…</p>
        )}
      </div>
    </div>
  );
}
